import { useFormik } from "formik";
import { CircularProgress, Fade, IconButton, Tooltip } from "@mui/material";
import { Delete, OpenInNew, Visibility } from "@mui/icons-material";
import CustomButton from "../../../Components/Atoms/CustomButton";
import * as Yup from "yup";
import { postExcelUploadVisitorLogRequest } from "../../../Redux/VisitorLogs/VisitorLogsActions";
import { useDispatch, useSelector } from "react-redux";
import InformationShower from "../../../Components/Atoms/InformationShower/Index";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useState } from "react";
import CustomDialog from "../../../Components/Molecules/CustomDialog";
import CustomSelect from "../../../Components/Atoms/CustomSelect";
import AvailableStatus from "../../../Components/Atoms/AvailableStatus";

const ImportExcel = ({ handleClose }) => {
  const dispatch = useDispatch();

  const { postExcelVisitorLogLoading, getVisitorLogsResponse } = useSelector(
    (state) => state.visitorLogReducer
  );

  const [copiedIndex, setCopiedIndex] = useState(null);
  const [copiedUUID, setCopiedUUID] = useState(false);

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopiedIndex(index);
    });
  };

  const handleCopyUUID = (uuid) => {
    navigator.clipboard.writeText(uuid).then(() => {
      setCopiedUUID(true);
    });
  };

  const FileUploader = ({
    title,
    required = false,
    name,
    handleChange,
    error,
    value,
    handleDelete,
    disabled,
    handleBlur,
    accept = "*",
  }) => {
    const handleViewPdf = () => {
      if (typeof value === "object") {
        var fileURL = URL.createObjectURL(value);
        return window.open(fileURL);
      } else if (typeof value === "string") {
        return window.open(`${process.env.REACT_APP_DOMAIN}/${value}`);
      } else return;
    };
    return (
      <div className="vendor_file_uploader">
        <div className="d-flex">
          <p className="mb-1">{title}</p>
          {required && <p className="erroStar">*</p>}
        </div>
        <label className="vendor_file_ip_wrp d-flex flex-column ">
          <input
            hidden
            type="file"
            accept={accept}
            onChange={handleChange}
            onBlur={handleBlur}
            name={name}
            disabled={disabled}
          />
          <img src="/Assets/Images/CLOUD.png" width="30px" className="image" />
          <p className="w-100 flex-fill text-truncate">
            {value ? value.name : "Click to upload"}
          </p>
        </label>

        {error && (
          <>
            <p className="errMsg">{error}</p>
          </>
        )}
        {value && (
          <div className="d-flex align-items-center justify-content-center gap-2 my-2">
            <IconButton color="error" onClick={() => handleDelete(name)}>
              <Delete />
            </IconButton>
            {false && (
              <IconButton color="info" onClick={handleViewPdf}>
                <OpenInNew />
              </IconButton>
            )}
          </div>
        )}
      </div>
    );
  };

  const formik = useFormik({
    initialValues: {
      file: "",
    },
    onSubmit: (values) => {
      dispatch(
        postExcelUploadVisitorLogRequest({
          ...values,
        })
      );
    },
    validationSchema: Yup.object().shape({
      file: Yup.string().required("Required"),
    }),
  });

  const data_list_formik = useFormik({
    initialValues: {
      field: "",
      uuid: "",
    },
  });

  const handleFileChange = (e) => {
    const file = e.currentTarget.files[0];
    if (file) {
      formik.setFieldValue("file", file);
    }
    e.target.value = null;
  };

  const handleFileDelete = (name) => {
    formik.setFieldValue(name, null);
  };

  const [showHeaders, setShowHeaders] = useState(false);
  const handleShowHeaders = () => {
    setShowHeaders((prev) => !prev);
  };
  const [openDataList, setOpenDataList] = useState({ open: false, data: [] });
  const handleOpenDataList = (data) => setOpenDataList({ open: true, data });
  const handleCloseDataList = () => {
    data_list_formik.resetForm();
    setOpenDataList({ open: false, data: [] });
    setCopiedUUID(false);
  };
  return (
    <>
      <CustomDialog
        maxWidth="sm"
        title={"DATA LIST"}
        handleClose={handleCloseDataList}
        open={openDataList.open}
      >
        <>
          <div className="row">
            <div className="col-md-6">
              <p className="mb-1">Field</p>
              <CustomSelect
                type="text"
                name="field"
                placeholder="SELECT FIELD"
                onChange={data_list_formik.handleChange}
                onBlur={data_list_formik.handleBlur}
                value={data_list_formik.values.field}
                formik={data_list_formik}
                data={openDataList.data}
              />
            </div>
            {data_list_formik.values.field && (
              <div className="col-md-6">
                <p className="mb-1">Value</p>
                <div className="d-flex-align-center gap-15">
                  <AvailableStatus
                    customCls={"index-green p-15 font-size-14 min-w-200"}
                    status={data_list_formik.values.field}
                  />
                  <Tooltip title={copiedUUID ? "Copied!" : "Copy"} arrow>
                    <IconButton
                      size="small"
                      onClick={() => {
                        handleCopyUUID(data_list_formik.values.field);
                      }}
                      style={{ padding: 4 }}
                    >
                      <ContentCopyIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </div>
              </div>
            )}
          </div>
          <div className="btnActnBar">
            <CustomButton
              label={"Close"}
              btnType="secondary"
              onClick={handleCloseDataList}
              action={"CANCEL"}
            />
          </div>
        </>
      </CustomDialog>

      <form onSubmit={formik.handleSubmit}>
        <div className="col-md-12">
          {postExcelVisitorLogLoading ? (
            <div className="d-flex-juscon-center-align-center">
              <div className="fd-column text-center p-4">
                <CircularProgress />
                <p>Please wait...</p>
              </div>
            </div>
          ) : (
            <FileUploader
              title="Document"
              handleChange={handleFileChange}
              handleDelete={handleFileDelete}
              name="file"
              error={formik.touched?.file && formik.errors?.file}
              required={true}
              value={formik.values.file}
              accept={".xlsx,.xls"}
            />
          )}
        </div>
        <div>
          <InformationShower
            bg_color={"#fdf1de"}
            para_color={"#e28c0c"}
            sentence={getVisitorLogsResponse?.import_config?.message || ""}
            icon_type={"HINT"}
            span_class="index-orange-mild"
            is_cursor={true}
            handleClick={handleShowHeaders}
          />
        </div>
        {showHeaders && (
          <>
            <div className="cntr mt-3 mb-3">
              <h6>AVAILABLE HEADERS</h6>
            </div>
            <div
              className="import_headers d-flex"
              style={{ flexWrap: "wrap", rowGap: "10px" }}
            >
              {getVisitorLogsResponse?.import_config?.headers?.map(
                (e, index) => {
                  const { name, value } = e;
                  return (
                    <>
                      <div
                        style={{ width: "50%" }}
                        key={index}
                        className="d-flex-align-center gap-15"
                      >
                        <span>{name}</span>
                        <Tooltip
                          title={copiedIndex === index ? "Copied!" : "Copy"}
                          arrow
                        >
                          <IconButton
                            size="small"
                            onClick={() => handleCopy(name, index)}
                            style={{ padding: 4 }}
                          >
                            <ContentCopyIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={"View Data List"} arrow>
                          {value.length > 0 && (
                            <IconButton
                              size="small"
                              onClick={() => handleOpenDataList(value)}
                              style={{ padding: 4 }}
                            >
                              <Visibility fontSize="small" />
                            </IconButton>
                          )}
                        </Tooltip>
                      </div>
                    </>
                  );
                }
              )}
            </div>
          </>
        )}
        <div className="btnActnBar">
          <CustomButton
            label={"Cancel"}
            btnType="secondary"
            onClick={handleClose}
            action={"CANCEL"}
          />
          <CustomButton
            label={postExcelVisitorLogLoading ? "Loading..." : "Upload"}
            type="submit"
            action="UPLOAD"
          />
        </div>
      </form>
    </>
  );
};
export default ImportExcel;
